import type { ChangeEvent, FC } from 'react';
import cx from 'classnames';
import { Checkbox } from '@THC/components/Checkbox';
import { useStore } from 'zustand';

import {
	EnquiriesSearchStore,
	EnquiriesSelectStore,
	EnquiriesStore,
	enquirySelectionService,
} from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

import styles from './EnquirySelectionList.module.scss';

export const EnquirySelectionListCheckbox: FC = () => {
	const enquiries = useStore(EnquiriesStore, (state) => state.enquiries);
	const selectedSaleIds = useStore(EnquiriesSelectStore, (state) => state.selectedSaleIds);
	const hasSearchText = useStore(EnquiriesSearchStore, (state) => !!state.keyword);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		enquirySelectionService.onToggleAll(e.currentTarget.checked);
	};

	return (
		<div className={cx(styles.checkboxAll, { [styles.disabled]: hasSearchText })}>
			<Checkbox
				formProps={{
					input: {
						checked: !!enquiries.length && enquiries.length === selectedSaleIds.length,
						disabled: hasSearchText,
						onChange: handleChange,
					},
				}}
				id="selectAllToSendEmail"
				label={T.translate('enquiryList.selectAll', { count: enquiries.length })}
			/>
		</div>
	);
};
